import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'w-full h-full',
})`
  .cert-img {
    height: calc(100% - 98px - 48px);
    object-fit: contain;
  }
  .download-btn {
    background: #e8b12c;
    border-radius: 10px;
    padding: 16px 78px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;
    color: white;
  }
  .copy-btn {
    background: transparent;
    border-radius: 10px;
    padding: 16px 78px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;
    color: black;
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const Content = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
